import { Eye, EyeOff } from 'lucide-react';
import { forwardRef, useState } from 'react';
import { TextInput, type TextInputProps } from './TextInput';
import styles from './form.module.css';

/** Password field with a large "Pokaż / Ukryj" toggle (typing on a phone in the field is error-prone). */
export const PasswordInput = forwardRef<HTMLInputElement, Omit<TextInputProps, 'type' | 'trailing'>>(
  function PasswordInput(props, ref) {
    const [visible, setVisible] = useState(false);
    return (
      <TextInput
        ref={ref}
        {...props}
        type={visible ? 'text' : 'password'}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        trailing={
          <button
            type="button"
            className={styles.reveal}
            onClick={() => setVisible((v) => !v)}
            aria-pressed={visible}
          >
            {visible ? <EyeOff aria-hidden="true" /> : <Eye aria-hidden="true" />}
            <span>{visible ? 'Ukryj' : 'Pokaż'}</span>
          </button>
        }
      />
    );
  },
);
